import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { EMPTY, Observable } from 'rxjs';
import { Action } from '@ngrx/store';

import * as MagnoliaConfigActions from './../actions/magnolia-config.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MagnoliaConfigService } from '../../services/magnolia-config.service';

@Injectable({
  providedIn: 'root',
})
export class MagnoliaConfigEffects {
  @Effect()
  magnoliaConfigOptionsGroups$: Observable<Action> = this.actions$.pipe(
    ofType(MagnoliaConfigActions.GET_OPTION_GROUPS_CONFIG),
    switchMap(() =>
      this.magnoliaConfigService.getOptionGroups().pipe(
        map(
          (data: IEntity<any>) =>
            new MagnoliaConfigActions.GetOptionGroupsConfigSuccess(data.value),
        ),
        catchError((a) => EMPTY),
      ),
    ),
  );

  @Effect()
  magnoliaConfigOptionsCategories$: Observable<Action> = this.actions$.pipe(
    ofType(MagnoliaConfigActions.GET_OPTIONS_CATEGORIES_CONFIG),
    switchMap(() =>
      this.magnoliaConfigService.getOptionsCategories().pipe(
        map(
          (data: IEntity<any>) =>
            new MagnoliaConfigActions.GetOptionsCategoriesConfigSuccess(
              data.value,
            ),
        ),
        catchError((a) => EMPTY),
      ),
    ),
  );

  @Effect()
  magnoliaConfigSettingsCategories$: Observable<Action> = this.actions$.pipe(
    ofType(MagnoliaConfigActions.GET_SETTINGS_CATEGORIES_CONFIG),
    switchMap(() =>
      this.magnoliaConfigService.getSettingsCategories().pipe(
        map(
          (data: IEntity<any>) =>
            new MagnoliaConfigActions.GetSettingsCategoriesConfigSuccess(
              data.value,
            ),
        ),
        catchError((a) => EMPTY),
      ),
    ),
  );

  @Effect()
  magnoliaConfigSettingsCtaFilter$: Observable<Action> = this.actions$.pipe(
    ofType(MagnoliaConfigActions.GET_SETTINGS_CTA_FILTER_CONFIG),
    switchMap(() =>
      this.magnoliaConfigService.getSettingsCtaFilter().pipe(
        map(
          (data: IEntity<any>) =>
            new MagnoliaConfigActions.GetSettingsCtaFilterConfigSuccess(
              data.value,
            ),
        ),
        catchError((a) => EMPTY),
      ),
    ),
  );

  @Effect()
  magnoliaConfigFreeVod$: Observable<Action> = this.actions$.pipe(
    ofType(MagnoliaConfigActions.GET_FREE_VOD_CONFIG),
    switchMap(() =>
      this.magnoliaConfigService.getFreeVod().pipe(
        map(
          (data: IEntity<any>) =>
            new MagnoliaConfigActions.GetFreeVodConfigSuccess(data.value),
        ),
        catchError((a) => EMPTY),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private magnoliaConfigService: MagnoliaConfigService,
  ) {}
}
